export const FORM_FIELD = {
  MENU_ITEM_TITLE: {
    name: 'title',
    placeholder: 'Enter the new title',
    rules: [{ required: true, message: 'Title is required' }],
  },
};
